import styled, { css } from "styled-components";
const Container = styled.div `
  max-width: ${props => (props.wide ? "none" : "1440px")};
  padding: ${props => (props.noGutter ? "0" : "0 15px")};
  margin: 0 auto;

  ${props => props.flex &&
    css `
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    `};
`;
export default Container;
